import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  ClinicPlatformBillingInvoice, ClinicPlatformBillingStatus, PayInvoiceResult,
} from '../../domain/models/platform-billing-status.model';
import { IPlatformBillingRepository } from '../../domain/repositories/platform-billing.repository';
import { PlatformBillingRemoteDatasource } from '../datasources/remote/platform-billing.remote-datasource';
import { PlatformBillingMapper } from '../mappers/platform-billing.mapper';

@Injectable()
export class PlatformBillingRepositoryImpl implements IPlatformBillingRepository {
  private readonly datasource = inject(PlatformBillingRemoteDatasource);
  private readonly mapper = inject(PlatformBillingMapper);

  public getStatus(organizationId: number): Observable<ClinicPlatformBillingStatus> {
    return this.datasource.getStatus(organizationId).pipe(
      map((dto) => this.mapper.toStatus(dto)),
    );
  }

  public getInvoices(organizationId: number, take: number): Observable<readonly ClinicPlatformBillingInvoice[]> {
    return this.datasource.getInvoices(organizationId, take).pipe(
      map((dtos) => this.mapper.toInvoices(dtos)),
    );
  }

  public downloadInvoice(organizationId: number, chargeId: string): Observable<Blob> {
    return this.datasource.downloadInvoice(organizationId, chargeId);
  }

  public payNow(organizationId: number, chargeId: string): Observable<PayInvoiceResult> {
    return this.datasource.payNow(organizationId, chargeId).pipe(
      map((dto) => this.mapper.toPayInvoiceResult(dto)),
    );
  }

  public confirmPay(organizationId: number, chargeId: string): Observable<PayInvoiceResult> {
    return this.datasource.confirmPay(organizationId, chargeId).pipe(
      map((dto) => this.mapper.toPayInvoiceResult(dto)),
    );
  }
}
